/*
 * Size scales measured from the wedge primitives (docs/specs/component-library/inventory/wedge-prototype.md).
 * Theme-independent, so they are plain numbers rather than CSS variables.
 */

export const space = { 0: 0, 1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 7: 28, 8: 32, 10: 40 } as const;

/* sm: icon boxes, inline actions · md: small buttons, wrapped pills · lg: callouts · xl: buttons, sticky bars ·
   card: cards, empty states, large buttons · icon: large icon tiles · sheet: overlay panels · pill: capsules. */
export const radius = { sm: 8, md: 10, lg: 12, xl: 14, card: 16, icon: 18, sheet: 24, pill: 999 } as const;

export const font = {
  micro: 11,
  caption: 12,
  footnote: 13,
  body: 14,
  callout: 15,
  headline: 16,
  title3: 17,
  title2: 18,
  title1: 22,
  large: 32,
} as const;

/* Line heights; body 1.45 is the wedge value. */
export const leading = { title: 1.2, heading: 1.3, body: 1.45, relaxed: 1.55 } as const;

export const weight = { regular: 400, medium: 500, semibold: 600, bold: 700, heavy: 800 } as const;

/* Product rule: every interactive control is at least 44px on its short axis. */
export const TOUCH_MIN = 44;

/* Exception (Thor ruling 2026-10-01): consoles dense controls keep the legacy owner console heights on desktop and
   grow to TOUCH_MIN at 860px and below (the legacy phone breakpoint, where its sidebar becomes a drawer).
   `size="dense"` on Button and IconButton, and the console SectionHeader info dot. */
export const DENSE_PHONE = '@media (max-width: 860px)';

/* The wedge's deliberate overlay layering; keep the order when adding layers. */
/* popover sits above overlay because a hover preview can open from inside a Sheet or Modal. drawer, dialog and palette
   carry the legacy owner console order (LIBRARY-GAPS row 44): drawer < dialog (a confirm opened from a drawer) <
   popover (an info tip inside either) < palette < toast. */
export const z = {
  coachMark: 450,
  prompt: 460,
  confirm: 500,
  overlay: 9000,
  drawer: 9090,
  dialog: 9200,
  popover: 9300,
  palette: 9400,
  toast: 9500,
} as const;

export const duration = {
  fast: 120,
  base: 160,
  exit: 170,
  sheetOut: 180,
  hover: 180,
  press: 200,
  lift: 220,
  slow: 240,
  sheetIn: 260,
  hide: 280,
  longPress: 450,
  ring: 620,
  spin: 800,
  shimmer: 1400,
  toast: 2000,
  toastAction: 6000,
} as const;

/* Control heights: button sizes, text fields, the pinned sticky CTA. */
export const control = { sm: 36, md: 50, lg: 56, field: 48, sticky: 52 } as const;

/* Drag distance past which a sheet dismisses. */
export const DRAG_CLOSE_PX = 90;
